import React, { useState, useEffect, useRef } from 'react';
import _ from 'lodash'

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import FormHelperText from '@mui/material/FormHelperText';

import { sub, getTime, format } from 'date-fns';
import { zhTW } from "date-fns/locale";
import { formatDate2 } from '../../utils/date';

import theme from '../../theme';

import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';

const SimpleDatePicker = (props) => {
  const { targetField, dateValue, handleDateInput, isError, errorMsg } = props;

  return (
    <>
      {
        <>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={zhTW}>
              <DatePicker
                value={dateValue}
                format="yyyy/MM/dd"
                views={['year', 'month', 'day']}
                onChange={(newValue) => {
                  handleDateInput(targetField, newValue)
                }}
                renderInput={(params) => {
                  return (
                    <TextField
                      {...params}
                      error={isError}
                      sx={{
                        minWdth: '20%',
                        '&.Mui-focused fieldset': {
                          borderColor: theme.palette.primary.main,
                        }
                      }}
                    />
                  )
                }}
              />

            </LocalizationProvider>

          </Box>

          <FormHelperText error={isError}>{isError ? errorMsg : null}</FormHelperText>

        </>
      }
    </>
  )
}

export default SimpleDatePicker;